<div mat-dialog-content class="einstallen-dialog-content">
    <kiene-einstallen-uebersicht
        class="einstallen-dialog-overview"
        [gruppe]="gruppe"
        [showPassReiter]="showPassReiter"
        [forceNewEinstallTierliste]="true"
    ></kiene-einstallen-uebersicht>
</div>
<div mat-dialog-actions class="einstallen-dialog-actions">
    <button mat-raised-button color="primary" data-cy="einstallen-liste-abschliessen-button" (click)="melden()">
        Liste abschließen und melden
    </button>
    <span class="spacer"></span>
    <button mat-button (click)="dialogRef.close()">Schlie&szlig;en</button>
</div>
